// API ендпоінти:
// https://furniture-store-v2.b.goit.study/api/categories - фільтрація по категоріям
// https://furniture-store-v2.b.goit.study/api/furniture - картки з меблями
// https://furniture-store-v2.b.goit.study/api/feedbacks - картки з відгуками
// **  ДОДАТКОВІ ЗАВДАННЯ  **
//  https://furniture-store-v2.b.goit.study/api/orders - форма з замовленням
// https://furniture-store-v2.b.goit.study/api/furniture?type=popular - картки з популярними товарами


export const BASE_URL = 'https://furniture-store-v2.b.goit.study/api/';